/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
import { Form, Row, Spin, Button, Col, message } from "antd";
import constants from "../../../constants/messages";
import SenderForm from "../../Address/senderForm";
import ReceiverForm from "../../Address/receiverForm";
import axios from "axios";
import { APIs } from "../../../utils/worker";
const AddressDetails = ({
  screen,
  currentScreen,
  upDateAllData,
  allData,
  check,
}) => {
  const { SENDER_ADDRESS, RECEIVER_ADDRESS } = constants;
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const [senderNameUppercase, setSenderNameUpperCase] = useState();
  const [receiverNameUppercase, setReceiverNameUpperCase] = useState();
  const [errorData, setErrorData] = useState({});
  const [senderEmailLowCase, setSenderEmailLowCase] = useState();
  const [receiverEmailLowCase, setReceiverEmailLowCase] = useState();
  const [senderDetails, setSenderDetails] = useState("");
  // let { addressDetails } = allData;
  const onFormLayoutChange = () => {
    setFormLayout("vertical");
  };

  useEffect(() => {
    form.resetFields();
  }, [check]);

  const { deliveryPincode, area, addressDetails } = allData || {};

  const onPincodeSender = async (values) => {
    if (values.target.value.length > 5) {
      setLoading(true);

      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${values.target.value}`
        );
        let res = await response.json();

        if (res?.length > 0) {
          {
            res?.map((data) => {
              setErrorData(data);
              data?.PostOffice?.map((data) => {
                form.setFieldsValue({
                  senderCity: data?.District,
                  senderState: data?.State,
                });
              });
            });
          }
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else if (values.target.value.length < 6) {
      form.setFieldsValue({
        senderCity: "",
        senderState: "",
      });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      receiverPincode: deliveryPincode,
      receiverAreaName: area || null,
    });
  }, [currentScreen]);

  useEffect(() => {
    if (currentScreen == 2) {
      onPincodeReceiver();
      getClient();
    }
  }, [currentScreen]);

  useEffect(() => {
    form.setFieldsValue({
      receiverEmail: receiverEmailLowCase,
      receiverName: receiverNameUppercase,
    });
  }, [
    senderNameUppercase,
    receiverNameUppercase,
    senderEmailLowCase,
    receiverEmailLowCase,
  ]);

  const getClient = () => {
    form.setFieldsValue({
      ...addressDetails,
    });
  };

  const onPincodeReceiver = async () => {
    setLoading(true);
    if (deliveryPincode > 5) {
      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${deliveryPincode}`
        );
        let res = await response.json();
        if (res.length > 0) {
          {
            res?.map((data) => {
              data?.PostOffice?.map((data) => {
                form.setFieldsValue({
                  receiverCity: data?.District,
                  receiverState: data?.State,
                  receiverPincode: deliveryPincode,
                });
              });
            });
          }
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };
  const handleScreen = () => {
    screen(3);
  };

  const [details, setDetails] = useState(
    JSON.parse(localStorage.getItem("accountBooking"))
  );

  useEffect(() => {
    setDetails(JSON.parse(localStorage.getItem("accountBooking")));
  }, [screen]);

  const onSubmitFormData = (values) => {
    let newDetails = {
      ...values,
      senderName: values?.senderName,
      senderEmail: senderEmailLowCase,
      receiverEmail: receiverEmailLowCase,
      receiverName: receiverNameUppercase,
    };
    // localStorage.setItem("accountBooking", JSON.stringify(newDetails));
    upDateAllData(newDetails);
    handleScreen();
  };

  const formProps = {
    name: "address",
    className: "register-form",
    initialValues: {
      layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  // useEffect(() => {
  //   onSubmitFormData();
  // }, []);

  const upperCaseSender = (e) => {
    let splitStr = e.target.value.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    setSenderNameUpperCase(splitStr.join(" "));
  };
  const upperCaseReceiver = (e) => {
    let splitStr = e.target.value.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return setReceiverNameUpperCase(splitStr.join(" "));
  };
  const senderEmailLowerCase = (e) => {
    let email = e.target.value.toLowerCase();
    return setSenderEmailLowCase(email);
  };
  const receiverEmailLowerCase = (e) => {
    let email = e.target.value.toLowerCase();
    return setReceiverEmailLowCase(email);
  };
  return (
    <div className="address-continer">
      {/* <Spin spinning={loading}> */}
      <Spin spinning={false}>
        <Form
          form={form}
          autoComplete="off"
          {...formProps}
          layout={formLayout}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          initialValues={{
            layout: formLayout,
            receiverPincode: deliveryPincode,
          }}
          onValuesChange={(e) => onFormLayoutChange(e)}
        >
          <Row className="form-container">
            <Col xl={1}></Col>

            <Col md={8} lg={12} xl={10} sm={24}>
              <div className="left-form" style={{ padding: "1.5rem" }}>
                <h2>{SENDER_ADDRESS}</h2>
                <SenderForm
                  onPincodeSender={onPincodeSender}
                  upperCaseSender={upperCaseSender}
                  senderEmailLowerCase={senderEmailLowerCase}
                  errorData={errorData}
                  disabled={true}
                />
              </div>
            </Col>
            <Col md={8} lg={12} xl={10} sm={24}>
              <div className="right-form" style={{ padding: "1.5rem" }}>
                <h2>{RECEIVER_ADDRESS}</h2>
                <ReceiverForm
                  upperCaseReceiver={upperCaseReceiver}
                  receiverEmailLowerCase={receiverEmailLowerCase}
                />
              </div>
            </Col>
            <Col xl={1}></Col>
          </Row>
          <hr className="divider" />
          <div className="d-flex flex-end p-1">
            <Button
              className="btn-style cancel-btn ml-1 w-10"
              onClick={() => screen(1)}
            >
              BACK
            </Button>
            <Button
              htmlType="submit"
              className="btn-style save-btn ml-1 w-10"
              // onClick={handleStepsChange}
            >
              SUBMIT
            </Button>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default AddressDetails;
